import { getAvailableLocales, useI18n } from '@runtime/core/i18n/i18n'
import { LOCALE_NAMES, localeLanguageTag } from '@runtime/core/i18n/localeConfig'
import styles from './PlayLanguageSelect.module.scss'

export default function PlayLanguageSelect() {
  const { t, locale, setLocale } = useI18n()
  return (
    <select
      className={styles.language}
      value={locale}
      onChange={event => setLocale(event.target.value)}
      aria-label={t('common.language')}
      data-testid="play-language"
    >
      {getAvailableLocales().map(value => (
        <option key={value} value={value} lang={localeLanguageTag(value)}>
          {LOCALE_NAMES[value] || value.toUpperCase()}
        </option>
      ))}
    </select>
  )
}
